// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LZ3H","icon":"styles_icon__jeG-t"};